module.exports = __webpack_public_path__ + "img/bd-lightning-sor.f9b23e0d.png";